import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initSentry } from './sentry';
import { applyTheme, readInitialDark } from './contexts/ThemeContext';
import { installSupportViewFetch } from './services/supportView';

// Initialize Sentry before rendering the app
initSentry();

// Telcofy support view (#557): send X-View-As-Company on API requests while it's on.
installSupportViewFetch();

// Set the theme class before the first paint so dark mode doesn't flash light.
applyTheme(readInitialDark());

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
